
  <div class="container">
  @if(showViews['generic']){
  <app-generic-template-ai [projectId]="projectId" [projectdataId]="projectdataId"></app-generic-template-ai>
  } @else if(showViews['university']){
  <app-template-ai-education></app-template-ai-education>
  } @else if(showViews['student']){
  <div class="student-mode-content">
    <app-ai-course-finder></app-ai-course-finder>
  </div>
  }
</div>
